// Perfilamiento por ramo (Bloque 1 · punto 2). Nunca pregunta ingresos ni salud; la edad solo como rango.
import mvp from '../datos/productos-mvp.json';
import { valorComercial } from './valuador';
import { PREGUNTAS_MATRIZ_AUTOS } from './matrizAutos';

export const ROTULO = mvp.rotulo;
export const COTIZA_ASESOR = mvp.cotiza_asesor;
export const productoMvp = (id) => mvp.productos.find((p) => p.id === id) || null;
export const nombreProducto = (p) => (p.aseguradora ? `${p.aseguradora} · ${p.plan}` : p.plan);
export const fmtPesos = (n) => `$${Math.round(n).toLocaleString('es-CO')}`;

const NO_APLICA_EDAD = 'Este plan no aplica a su edad; le ayuda un asesor.';

// Las 4 preguntas de perfilamiento de Carlos (WhatsApp 14-oct): comunes a todos los casos.
// Perfilan el riesgo (S2); nunca preguntan ingresos ni salud.
const SOLO_YO = 'Solo yo';
const COMUNES = [
  {
    id: 'dependen', label: 'Quién depende', q: '¿Quién depende de ti?', qu: '¿Quién depende de usted?', multi: true, excluye: SOLO_YO,
    opts: [SOLO_YO, 'Mi pareja', 'Mis hijos', 'Mis papás'],
  },
  {
    id: 'diaadia', label: 'Día a día', q: '¿Cómo es tu día a día? Marca las que apliquen.', qu: '¿Cómo es su día a día? Marque las que apliquen.', multi: true,
    opts: ['Ando en moto seguido', 'Manejo carro seguido', 'Trabajo desde casa', 'Hago deportes de aventura', 'Viajo fuera del país'],
  },
  {
    id: 'preocupa', label: 'Lo que más le preocupa', q: '¿Qué es lo que más te preocupa?', qu: '¿Qué es lo que más le preocupa?',
    opts: ['Un diagnóstico grave, como cáncer o un infarto', 'Los gastos médicos del día a día', 'Que mi familia quede bien si me pasa algo', 'Que mis deudas no queden a cargo de nadie'],
  },
  {
    id: 'ahorro', label: 'Colchón de ahorro', q: 'Si mañana no pudieras trabajar, ¿cuántos meses aguantarías con tus ahorros?', qu: 'Si mañana no pudiera trabajar, ¿cuántos meses aguantaría con sus ahorros?',
    opts: ['Menos de 3 meses', 'De 3 a 6 meses', 'De 6 a 12 meses', 'Más de 12 meses'],
  },
];
// Autos: las preguntas de vida no sirven para perfilar un carro (Carlos, sesión #5). Se perfila con su matriz:
// conductor (edad, estado civil, licencia, profesión) y uso (uso, parqueo, GPS, km, horas, zona).
const COMUNES_AUTOS = PREGUNTAS_MATRIZ_AUTOS;
const ANIO_ACTUAL = new Date().getFullYear();
const anioDe = (txt) => { const m = String(txt || '').match(/(19|20)\d{2}/); return m ? Number(m[0]) : null; };
// Usado: conexión SIMULADA a la guía de valores (valuador de mercado con la metodología pública de Fasecolda)
const notaValorCarro = (v) => {
  const a = anioDe(v);
  if (!a) return 'No vi el año del carro: si es 0 km, el valor sale de la factura; si es usado, de la guía Fasecolda. El asesor lo confirma.';
  if (a > ANIO_ACTUAL + 1) return `Revisa el año: ${a} todavía no se vende. El asesor lo confirma contigo.`;
  if (a >= ANIO_ACTUAL) return 'Como es 0 km, el valor se toma de la factura.';
  const r = valorComercial(v);
  if (!r) return `La demo tiene valores de referencia solo para algunos modelos y ese modelo ${a} no está en la muestra; el asesor te confirma el valor comercial.`;
  return `Consulté el valor comercial: tu ${r.vehiculo} está en ${fmtPesos(r.valor)} (referencia de mercado, ${r.ofertas} ofertas, oct-2026 · conexión simulada de la demo). Antes de emitir, la aseguradora lo valida con la guía Fasecolda.`;
};
const valorDerivado = (v) => {
  const a = anioDe(v);
  const r = a && a < ANIO_ACTUAL ? valorComercial(v) : null;
  return r ? { valor: r.valor } : {};
};
// Se llena solo con la consulta simulada; nunca se le pregunta al cliente
const VALOR_MERCADO = { id: 'valor', label: 'Valor comercial (referencia de mercado)', tipo: 'pesos', q: '', skip: () => true };

// Del recorrido inicial (pantalla «¿Quién depende de ti hoy?») a la pregunta 1, para no preguntarla dos veces
const DEPENDEN_DE_LEAD = { 'Sin dependientes': SOLO_YO, Pareja: 'Mi pareja', Hijos: 'Mis hijos', Padres: 'Mis papás' };
export const previasDeLead = (lead) => {
  const q = lead && lead.quienes;
  if (!q) return {};
  const v = String(q).split(',').map((s) => DEPENDEN_DE_LEAD[s.trim()]).filter(Boolean);
  return v.length ? { dependen: v.join(', ') } : {};
};

export const PREGUNTAS = {
  // Autos: carro, 0 km, crédito y accesorios; luego las 10 variables de la matriz de Carlos.
  autos: [
    { id: 'carro', label: 'Carro', q: '¿Qué carro es? Escribe marca, línea y año.', tipo: 'texto', ph: 'Ej.: Mazda CX-30 2024', nota: notaValorCarro, derivar: valorDerivado },
    VALOR_MERCADO,
    {
      id: 'estado', label: '0 km o usado', q: '¿Es 0 km o usado?', opts: ['0 km', 'Usado'],
      nota: (v) => (v === '0 km' ? 'El valor se toma de la factura.' : 'El valor se toma de la guía Fasecolda vigente.'),
    },
    { id: 'prenda', label: 'Crédito o prenda', q: '¿Tiene crédito o prenda con un banco?', opts: ['Sí, tiene crédito o prenda', 'No'] },
    { id: 'accesorios', label: 'Accesorios', q: '¿Le pusiste algo que no venía de fábrica, como rines, sonido o blindaje?', opts: ['No', 'Sí'] },
    { id: 'acc_det', label: 'Accesorios declarados', q: 'Cuéntame qué le pusiste y cuánto costó cada cosa. Así queda asegurado también.', tipo: 'accesorios', skip: (a) => a.accesorios !== 'Sí' },
    ...COMUNES_AUTOS,
  ],
  // Caso A: 0 km y crédito ya se saben
  autos_a: [
    { id: 'carro', label: 'Carro', q: '¿Qué carro es? Escribe marca, línea y año.', tipo: 'texto', ph: `Ej.: Mazda CX-30 ${ANIO_ACTUAL}`, nota: notaValorCarro, derivar: valorDerivado },
    VALOR_MERCADO,
    { id: 'accesorios', label: 'Accesorios', q: '¿Le pusiste algo que no venía de fábrica, como rines, sonido o blindaje?', opts: ['No', 'Sí'] },
    { id: 'acc_det', label: 'Accesorios declarados', q: 'Cuéntame qué le pusiste y cuánto costó cada cosa. Así queda asegurado también.', tipo: 'accesorios', skip: (a) => a.accesorios !== 'Sí' },
    ...COMUNES_AUTOS,
  ],
  vida: [
    ...COMUNES,
    {
      id: 'edad', label: 'Rango de edad', q: 'Tu rango de edad (solo para saber qué planes aplican):', qu: 'Su rango de edad (solo para saber qué planes aplican):', opts: ['18–35', '36–45', '46–55', '56–65', '66–70', 'Más de 70'],
      corte: (v) => (v === 'Más de 70' ? NO_APLICA_EDAD : null),
    },
  ],
  accidentes: [
    ...COMUNES,
    { id: 'pago', label: 'Forma de pago', q: '¿Prefiere un pago único semestral o un pago mensual?', opts: ['Pago único semestral', 'Pago mensual'] },
    { id: 'renta', label: 'Renta diaria', q: '¿Le sirve una renta diaria si queda hospitalizado?', opts: ['Sí, me sirve', 'No la necesito'] },
    {
      id: 'edad', label: 'Rango de edad', q: 'Rango de edad (solo para verificar si el producto aplica):', opts: ['18–40', '41–50', '51–60', '61–69', 'Más de 69'],
      corte: (v) => (v === 'Más de 69' ? NO_APLICA_EDAD : null),
    },
  ],
  salud: [
    ...COMUNES,
    { id: 'prioridad', label: 'Lo que más le importa', q: '¿Qué le importa más: consultas con especialista, visitas a domicilio u odontología?', opts: ['Consultas con especialista', 'Visitas a domicilio', 'Odontología'], libre: true },
    { id: 'yatiene', label: 'Plan actual', q: '¿Ya tiene medicina prepagada o un plan complementario?', opts: ['Sí, medicina prepagada', 'Sí, plan complementario', 'No tengo'], libre: true },
  ],
  desempleo: [
    ...COMUNES,
    {
      id: 'tipo', label: 'Trabajo', q: '¿Es empleado o independiente?', opts: ['Empleado', 'Independiente'],
      nota: (v) => (v === 'Independiente' ? 'El seguro de desempleo es para empleados; para independientes existe la cobertura por incapacidad.' : null),
    },
    { id: 'credito', label: 'Crédito', q: '¿Qué crédito quiere proteger?', opts: ['Libre inversión', 'Libranza', 'Hipotecario'], skip: (a) => a.tipo === 'Independiente' },
    { id: 'monto', label: 'Monto desembolsado', q: 'Monto desembolsado aproximado (en pesos).', tipo: 'pesos', ph: 'Ej.: 20.000.000' },
    { id: 'cuota', label: 'Cuota mensual', q: 'Cuota mensual aproximada del crédito (en pesos).', tipo: 'pesos', ph: 'Ej.: 650.000', skip: (a) => a.tipo === 'Independiente' },
  ],
};

export const RAMO_DE_CATEGORIA = { 'Automóvil': 'autos', 'Vida': 'vida', 'Accidentes personales': 'accidentes', 'Desempleo': 'desempleo', 'Salud': 'salud' };

// Salud: si la persona menciona una enfermedad, no se registra y pasa al asesor
export const MENCIONA_ENFERMEDAD = /enferm|diagn|c[aá]ncer|diabet|hipertens|presi[oó]n alta|asma|tiroid|artritis|epoc|vih|lupus|renal|coraz[oó]n|card[ií]|tumor|depresi|ansiedad|tratamiento|cirug|operaci[oó]n|alergi|migra|epilep|colesterol/i;
export const SALUD_ASESOR = 'Eso lo revisa un asesor con usted.';

export const siguientePregunta = (set, answers, from) => {
  const qs = PREGUNTAS[set];
  for (let i = from; i < qs.length; i += 1) if (answers[qs[i].id] == null && !(qs[i].skip && qs[i].skip(answers))) return i;
  return -1;
};

// Opciones del comparador según el perfil (siempre 3, o las que haya)
export function opcionesComparador(ramo, answers) {
  const r = mvp.ramos[ramo];
  if (ramo === 'desempleo' && answers.tipo === 'Independiente') return { ids: r.independiente, extra: [] };
  if (ramo === 'desempleo' && answers.credito) {
    const elegido = r.comparar.find((id) => productoMvp(id).credito === answers.credito);
    return { ids: [elegido, ...r.comparar.filter((id) => id !== elegido)], extra: [], suyo: elegido };
  }
  return { ids: r.comparar, extra: r.ver_mas || [] };
}

const rango = (v) => {
  if (!v) return null;
  const m = String(v).match(/(\d+)\D+(\d+)/);
  if (m) return [Number(m[1]), Number(m[2])];
  const n = String(v).match(/(\d+)/);
  return n ? [Number(n[1]) + 1, 120] : null;
};
const solapa = (a, b) => a && b && a[0] <= b[1] && b[0] <= a[1];

// Celda de prima: rótulo "La cotiza el asesor" si se cotiza en línea; ejemplo calculado en desempleo
export function primaCelda(p, answers) {
  if (p.prima.en_linea) return { texto: COTIZA_ASESOR };
  const r = rango(answers.edad);
  if (p.prima.tarifa_edad && r && !solapa(r, p.prima.tarifa_edad)) return { texto: `${p.prima.texto}. Para su rango de edad: ${COTIZA_ASESOR.toLowerCase()}` };
  const c = p.prima.calc;
  if (c && c.tipo === 'por_millon' && answers.monto) {
    return { texto: p.prima.texto, ejemplo: `Ejemplo con su monto: ${fmtPesos((answers.monto / 1e6) * c.valor)} al mes` };
  }
  if (c && c.tipo === 'pct_cuota' && answers.cuota) {
    return { texto: p.prima.texto, ejemplo: `Ejemplo con su cuota: ${fmtPesos((answers.cuota * c.valor) / 100)} al mes` };
  }
  return { texto: p.prima.texto };
}

export const noAplicaEdad = (p, answers) => {
  const r = rango(answers.edad);
  return Boolean(p.edad && p.edad.min != null && r && !solapa(r, [p.edad.min, p.edad.max]));
};

export const valorRespuesta = (q, v) => (q.tipo === 'pesos' ? fmtPesos(v) : v);
